export function clearLocalStorageWithoutToken() {
  const localStorageItems = { ...localStorage };
  Object.keys(localStorageItems).forEach((element) => {
    if (element !== 'pcTokenHardWrite') localStorage.removeItem(element);
  });
}
